import AgentMonitoring from "../Components/AgentMonitoring/AgentMonitoring";

const AgentMonitoringPage = () => {
  return <AgentMonitoring />;
};

export default AgentMonitoringPage;
